/*=========================================================================================
  File Name: moduleAuthActions.js
  Description: Auth Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import jwt from '../../http/requests/auth/jwt/index.js'
import axios from '../../http/axios/index.js'
import axiosLDAP from '../../http/axiosLDAP/index.js'

import router from '@/router'
import store from '../store'

export default {
  // JWT
  loginJWT({ commit }, payload) {
    return new Promise((resolve, reject) => {
      // jwt.login(
      //   payload.userDetails.email,
      //   payload.userDetails.password,
      //   payload.userDetails.dynamicKey
      // )
      //   .then(response => {
      //     //console.log("response 1", response);
      //     // If there's user data in response
      //     if (response.data.access_token) {
      //       // Navigate User to homepage
      //       // Set accessToken
      //       localStorage.setItem(
      //         'accessToken',
      //         response.data.access_token
      //       )
      //       // Set bearer token in axios
      //       commit('SET_BEARER', response.data.access_token)
      //       commit('retrieveToken', response.data.access_token)
      //       // Update user details
      //       try {

      const loginTmp = {
        usuario: payload.email,
        password: payload.password
      }

      axios
        .post('/getLoginUser', loginTmp, {
          headers: {
            //Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
            'Content-type': 'application/json; charset=utf-8',
            'Access-Control-Allow-Origin': '*'
          }
        })
        .then(response => {
          if (response.data !== null) {
            if (response.data.nuOK === 0 && (response.data.usuario !== null || response.data.usuario !== undefined)) {
              console.log('response user', response)

              commit('UPDATE_USER_INFO', response.data.usuario, {
                root: true
              })

              // TODO, Set accessToken
              localStorage.setItem(
                'accessToken',
                '12345678'
              )

              //const param = `/${router.history.current.params.nameCompany}`
              const param = `/${response.data.usuario.desc_copmany}`
              const idRequest = router.history.current.params.idRequest

              router.replace(
                idRequest ? `${param}/caso/${idRequest}`
                  : param + (router.currentRoute.query.to || '/')
              )
              resolve(response)
            } else {
              const error = {
                response: { data: 'Usuario o contraseña incorrecta.' }
              }
              reject(error)
            }
          } else {
            const error = {
              response: { data: 'No se pudo realizar la conexión, inténtelo de nuevo más tarde.' }
            }
            reject(error)
          }
        })
        .catch(error => {
          reject(error)
        })
      //     } catch (ex) {
      //       console.error('outer', ex.message)
      //     }
      //   } else {
      //     reject({ message: 'Wrong Email or Password' })
      //   }
      // })
      // .catch(error => {
      //   reject(error)
      // })
    })
  },
  loginLDAP({ commit }, payload) {
    return new Promise((resolve, reject) => {
      const loginTmp = {
        username: payload.email,
        password: payload.password
      }

      axiosLDAP
        .post('https://cvc-fileback.arqbs.com/authWithLDAP/', loginTmp, {
          headers: {
            //Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
            'Content-type': 'application/json; charset=utf-8',
            'Access-Control-Allow-Origin': '*'
          }
        })
        .then(response => {
          console.log('response', response)
          if (response.data !== null) {
            if (response.data.nuOK === 0 && (response.data.user !== null || response.data.user !== undefined)) {
              console.log('response user', response.data)

              const usreLDAP = response.data.user

              /*let*/ const mail = loginTmp.username
              /*let domain = ''

              if (mail.length > 7) {
                domain = mail.substr(mail.length - 7)

                if (domain === 'cvc.gov') {
                  mail = `${mail}.co`
                }
              }*/

              axios.post('/getLoginUserByEmail', { email: mail }, {
                headers: {
                  //Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
                  'Content-type': 'application/json; charset=utf-8',
                  'Access-Control-Allow-Origin': '*'
                }
              }).then((response) => {

                console.log('response', response)

                const area = {
                  id: -1,
                  descripcion: ''
                }

                if (response.data.nuOK === 0 && (response.data.usuario !== null || response.data.usuario !== undefined)) {
                  commit('UPDATE_USER_INFO', { ...usreLDAP, ...response.data.usuario, area }, {
                    root: true
                  })

                  // TODO, Set accessToken
                  localStorage.setItem(
                    'accessToken',
                    '12345678'
                  )

                  //const param = `/${  router.history.current.params.nameCompany}`
                  const param = `/${response.data.usuario.desc_copmany}`
                  const idRequest = router.history.current.params.idRequest

                  router.replace(
                    idRequest ? `${param}/caso/${idRequest}`
                      : param + (router.currentRoute.query.to || '/')
                  )
                  resolve(response)
                } else {
                  const error = {
                    response: { data: 'Usuario o contraseña incorrecta.' }
                  }
                  reject(error)
                }
              }).catch(() => {
                const error = {
                  response: { data: 'No se pudo realizar la conexión, inténtelo de nuevo más tarde.' }
                }
                reject(error)
              })
            } else {
              const error = {
                response: { data: 'Usuario o contraseña incorrecta.' }
              }
              reject(error)
            }
          } else {
            const error = {
              response: { data: 'No se pudo realizar la conexión, inténtelo de nuevo más tarde.' }
            }
            reject(error)
          }
        })
        .catch(error => {
          console.log('error', error)

          const errorTmp = {
            response: { data: 'No se pudo realizar la conexión, inténtelo de nuevo más tarde.' }
          }

          if (error.response !== null && error.response !== undefined) {
            if (error.response.data !== null && error.response.data !== undefined) {
              if (error.response.data.v_errm) {
                errorTmp.response.data = error.response.data.v_errm
              }
            }
          }

          reject(errorTmp)
        })
    })
  },
  registerUserJWT({ commit }, payload) {
    const {
      displayName,
      email,
      password,
      confirmPassword
    } = payload.userDetails

    return new Promise((resolve, reject) => {
      // Check confirm password
      if (password !== confirmPassword) {
        reject({
          message: 'Password doesn\'t match. Please try again.'
        })
      }

      jwt.registerUser(displayName, email, password)
        .then(response => {
          // Redirect User

          //const param = `/${  router.history.current.params.nameCompany}`
          const param = `/${response.data.usuario.desc_copmany}`
          const idRequest = router.history.current.params.idRequest

          router.replace(
            idRequest ? `${param}/caso/${idRequest}`
              : param + (router.currentRoute.query.to || '/')
          )

          // Update data in localStorage
          localStorage.setItem(
            'accessToken',
            response.data.accessToken
          )
          commit('UPDATE_USER_INFO', response.data.userData, {
            root: true
          })

          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  fetchAccessToken() {
    return new Promise(resolve => {
      jwt.refreshToken().then(response => {
        resolve(response)
      })
    })
  },
  retrieveToken(context, credentials) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/login', {
          username: credentials.username,
          password: credentials.password
        })
        .then(response => {
          //console.log(response)
          const token = response.data.access_token
          localStorage.setItem('accessToken', token)
          context.commit('retrieveToken', token)

          resolve(response)
        })
        .catch(error => {
          //console.log(error)
          reject(error)
        })
    })
  },
  destroyToken(context) {
    console.log(store.state.auth.isUserLoggedIn())

    if (store.state.auth.isUserLoggedIn()) {
      return new Promise((resolve, reject) => {
        // axios
        //   .post('/api/logout', '', {
        //     headers: {
        //       Authorization:
        //                         `Bearer ${  localStorage.getItem('accessToken')}`
        //     }
        //   })
        //   .then(response => {
        //console.log(response)
        localStorage.removeItem('accessToken')
        localStorage.removeItem('userInfo')
        context.commit('destroyToken')

        context.commit('UPDATE_USER_INFO', null, {
          root: true
        })

        //resolve(response)
        resolve()
        // })
        // .catch(error => {
        //   //console.log(error)
        //   localStorage.removeItem('accessToken')
        //   localStorage.removeItem('userInfo')
        //   context.commit('destroyToken')
        //   reject(error)
        // })
      })
    } else {
      console.log('no se encuentra autenticado')
    }
  },
  sendDynamicKey(context, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/login/genKey', {
          email: payload.userDetails.email
        })
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          //console.log(error)
          reject(error)
        })
    })
  },
  updatePassword(context, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          '/api/user/updatePassword',
          {
            newPassword: payload.userDetails.password
          },
          {
            headers: {
              Authorization:
                `Bearer ${localStorage.getItem('accessToken')}`
            }
          }
        )
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
}
